import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import TileSprite = Phaser.GameObjects.TileSprite;
import Sprite = Phaser.GameObjects.Sprite;
import { ObjectPool } from './objectPool';
import GameObject = Phaser.GameObjects.GameObject;

export class PathView extends Container {
    private sky: Sprite;
    private parallaxObjects: (ObjectPool | TileSprite)[] = [];
    private tileSprites: TileSprite[] = [];

    constructor(scene: Scene) {
        super(scene);
        this.init();
    }

    public start() {
        this.scene.events.on('update', this.updateParallax, this);
    }

    public stop() {
        this.scene.events.off('update', this.updateParallax, this);
    }

    private init() {
        const { width, height } = this.scene.scale;
        this.sky = this.scene.add.sprite(width / 2, height, 'sky.png');
        this.add(this.sky);
        // this.sky.width = width;
        // this.sky.height = height;
        this.sky.setOrigin(0.5, 1);

        this.parallaxObjects = [
            this.addTileSprite('bkgBuildings', 230, height - 50),
            this.addTileSprite('bkgTrees', 230, height - 20),
            new ObjectPool(this, 'game', 'clouds', 2, 1555, 300),
            new ObjectPool(this, 'game', 'buildings', 11, 161, height),
            new ObjectPool(this, 'trees', 'large', 1, 1921, 1100),
            new ObjectPool(this, 'trees', 'medium', 4, 485, 1100),
            new ObjectPool(this, 'trees', 'small', 2, 933, 1100),
            this.addTileSprite('bush', 587, 460),
            new ObjectPool(this, 'game', 'vines', 2, 833, 1100),
            this.addTileSprite('smallForegroundTrees', 178, height + 35),
            this.addTileSprite('fog', 178, height + 20),
        ];
    }

    private updateParallax() {
        const totalSpeed = 1;
        this.parallaxObjects.forEach((p, i) => {
            if (p instanceof ObjectPool) {
                const speed = totalSpeed * (i + 1);
                p.pool.forEach((e) => {
                    e.x -= speed;
                    if (e.x + e.displayWidth / 2 < 0 && e.parentContainer) {
                        p.delete(e);
                        p.get();
                    }
                });
            }
            if (p instanceof TileSprite) {
                p.tilePositionX += totalSpeed * (i + 1);
            }
        });
        this.tileSprites.forEach((e, i) => {});
    }

    private addTileSprite(frameName: string, height: number, y: number): TileSprite {
        const { width } = this.scene.scale;
        const sprite = this.scene.add.tileSprite(0, y, width, height, `${frameName}.png`);
        sprite.setOrigin(0, 1);
        this.add(sprite);
        this.tileSprites.push(sprite);
        return sprite;
    }
}

